import * as types from "../constants/ecpWorkflowConstants"

const initialState = {
    isConfirmationModal: {
        modal: false,
        id: null,
        type: null,
    },
    isGlossaryModal: {
        modal: false,
        type: null,
        index: null,
    },
}

export default function EcpWorkflowRecucer(state=initialState, action) {
    switch(action.type) {
        case types.ECP_WORKFLOW_IS_CONFIRMATION_MODAL:
            return {
                ...state,
                isConfirmationModal: action.payload.isConfirmationModal,
            }
        case types.ECP_WORKFLOW_IS_GLOSSARY_MODAL:
            return {
                ...state,
                isGlossaryModal: action.payload.isGlossaryModal,
            }
        case types.CLEAN_ECP_WORKFLOW_CONTEXT:
            return initialState
        default:
            return state
    }
}